import React, { useState } from 'react';
import $api from '../../http';
import ModalDialog from '../ModalDialog';
import '../../css/order-viewer.css';

const TraderOrderTableMobile = ({ orders, processing, filter }) => {
    const [activeModal, setActiveModal] = useState('no');
    const [orderToComplete, setOrderToComplete] = useState(null);
    const [isCompleteRequestNow, setIsCompleteRequestNow] = useState(false);

    const confirmOrder = async (orderId) => {
        setIsCompleteRequestNow(true);
        try {
            await $api.get(`/confirm_order?orderId=${orderId}`);
        } catch (error) {
            console.error(error);
        } finally {
            setIsCompleteRequestNow(false);
        }
    };

    if (!orders.length) {
        return processing
            ? <img src={require('../../img/loading.gif')} height={'40px'} className={'margin-left-20'} />
            : <h2>Нет ничего соответствующего вашему запросу</h2>;
    }

// Замени блок return в TraderOrderTableMobile на это:
    return (
        <div className="mobile-order-list">
            {orders.map(order => {
                // ... (фильтрация остаётся без изменений)
                return (
                    <div key={order.id} className={`mobile-order-card ${order.status}-tab`}>
                        <div className="order-header">
                            <strong>#{order.number}</strong>
                        </div>
                        <div className="order-date">
                            {new Date(order.openDate).toLocaleString([], {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </div>

                        <div className="order-section">
                            <div>
                                <strong>Сумма:</strong>
                                <span>{order.amount} ₽ {order.amountAfterFee && `(${order.amountAfterFee} ₽)`}</span>
                            </div>
                            <div>
                                <strong>Тип трафика:</strong>
                                <span>{order.trafficType || '—'}</span>
                            </div>
                        </div>

                        <div className="order-section">
                        <div>
                                <strong>Банк:</strong>
                                <span>{order.card?.bank || '—'}</span>
                            </div>
                            <div>
                                <strong>Карта:</strong>
                                <span>{order.card?.number ? `*${order.card.number.slice(-4)}` : '—'}</span>
                            </div>
                        </div>

                        <div className="order-section">
                            <div>
                            <strong>Статус:</strong>
                                <span>{order.status || '—'}</span>
                            </div>
                            {order.status !== "opened"
                                ?
                                <div>
                                    <strong>Профит:</strong>
                                    <span>{order.traderProfit?.toFixed(2)} USDT</span>
                                </div>
                                :
                                null
                            }
                        </div>

                        {order.status === 'opened' && (
                            <button
                                disabled={isCompleteRequestNow}
                                className="mobile-confirm-button"
                                onClick={() => {
                                    setActiveModal('progress');
                                    setTimeout(() => setActiveModal('active'), 100);
                                    setOrderToComplete(order);
                                }}
                            >
                                Подтвердить
                            </button>
                        )}
                    </div>
                );
            })}
            <ModalDialog
                active={activeModal}
                setActive={setActiveModal}
                action={() => {
                    confirmOrder(orderToComplete?.id)
                }}
                message={`Вы подтверждаете поступление ${orderToComplete?.amount} ₽ по заказу #${orderToComplete?.number}?`}
                purpose={"choice"}
            />
        </div>
    );
};

export default TraderOrderTableMobile;
